var _polygon, _polygon2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIfGate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    baseProfile: "tiny",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "25.303,69.394 20,74.697 14.697,69.394 9.394,74.697 14.697,80 9.394,85.303 14.697,90.606 20,85.303   25.303,90.606 30.606,85.303 25.303,80 30.606,74.697 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "77.348,80 72.045,74.697 66.742,80 77.348,90.606 93.258,74.697 87.955,69.394 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,31.25c6.203,0,11.25-5.047,11.25-11.25S56.203,8.75,50,8.75S38.75,13.797,38.75,20S43.797,31.25,50,31.25z M50,16.25  c2.068,0,3.75,1.682,3.75,3.75s-1.682,3.75-3.75,3.75s-3.75-1.682-3.75-3.75S47.932,16.25,50,16.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5,65h5V52.5H65.59L52.5,45.955V35h-5v10.955L34.41,52.5H17.5V65h5v-7.5h11.91L50,65.295L65.59,57.5H77.5V65z M50,59.705  L40.59,55L50,50.295L59.41,55L50,59.705z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIfGate);
export default __webpack_public_path__ + "static/media/if-gate.73b2254fcbdd6b9b3a81035fd08ac0e6.svg";
export { ForwardRef as ReactComponent };